import { useContext } from 'react'

import LayoutContext from 'presentation/components/layout/context/LayoutContext'

const useLayoutContextStates = () => useContext(LayoutContext)

export default useLayoutContextStates
